// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jy-2";
export var container = "_jy-4";
export var dismissButton = "_jy-3";
export var hasPaddingBottom = "_jy-6";
export var last = "_jy-e";
export var scrollbarThumb = "_jy-c";
export var scrollbarTrack = "_jy-b";
export var selected = "_jy-9";
export var spin = "_jy-1";
export var spinning = "_jy-0";
export var suggestionItem = "_jy-d";
export var suggestionsPanel = "_jy-5";
export var tonePill = "_jy-8";
export var tonesContainer = "_jy-7";
export var unselected = "_jy-a";